import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Header from "../../../Components/Header/Header";
import { LeftSettings } from "../LeftSettings";
import LeftMenu from "../../../Components/LeftMenu/LeftMenu";
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import { toast } from "react-toastify";
import { withRFSToken } from "../../../Services/axios.js";

const IP_LIST_API = "vehicle-management/driver-visitor-ip-list";
const IP_SAVE_API = "vehicle-management/save-driver-visitor-ip";
const IP_DELETE_API = "vehicle-management/delete-driver-visitor-ip";

const DriverVisitorSettings = () => {
  const isMounted = useRef(false);
  const gridRef = useRef(null);

  const [gridData, setGridData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [editId, setEditId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(null);
  const [formData, setFormData] = useState({
    ip_address: "",
    description: "",
  });

  const shpTab = localStorage.getItem("FSTab");
  const SBack = localStorage.getItem("SettingsBack");

  const fetchIPList = async () => {
    try {
      const res = await withRFSToken.get(IP_LIST_API);
      const rows =
        res.data?.Rows ||
        res.data?.rows ||
        res.data?.response_data ||
        res.data ||
        [];
      setGridData(rows);
    } catch (error) {
      console.error("Error fetching IP list:", error);
      toast.error("Unable to fetch IP addresses");
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchIPList();
    isMounted.current = true;
  }, []);

  const validateFormData = () => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
    if (!formData.ip_address) {
      toast.error("IP address is required");
      return false;
    }
    if (!ipRegex.test(formData.ip_address)) {
      toast.error("Enter a valid IPv4 address");
      return false;
    }
    return true;
  };

  const handleAddButtonClick = () => {
    setEditId("");
    setFormData({ ip_address: "", description: "" });
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
    setFormData({ ip_address: "", description: "" });
    setEditId("");
  };

  const handleSubmit = async () => {
    if (!validateFormData()) return;
    const payload = { ...formData, ...(editId ? { id: editId } : {}) };
    try {
      const res = await withRFSToken.post(IP_SAVE_API, payload);
      if (res.data?.response_code === 200 || res.data?.status === "success") {
        toast.success(editId ? "IP updated successfully" : "IP added successfully");
        fetchIPList();
        handleModalClose();
      } else {
        toast.error(res.data?.response_msg || "Unable to save IP address");
      }
    } catch (error) {
      console.error("Error saving IP:", error);
      toast.error("Error saving IP address");
    }
  };

  const handleShowConfirmation = (fn) => {
    setDeleteFunction(() => fn);
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    if (deleteFunction && deleteId) {
      deleteFunction(deleteId);
    }
    setShowConfirmation(false);
  };

  const handleCancelDelete = () => {
    setDeleteId("");
    setShowConfirmation(false);
  };

  const deleteRow = async (selectedId) => {
    try {
      const res = await withRFSToken.post(IP_DELETE_API, { id: selectedId });
      if (res.data?.response_code === 200 || res.data?.status === "success") {
        toast.success("IP removed successfully");
        fetchIPList();
        setDeleteId("");
      } else {
        toast.error(res.data?.response_msg || "Unable to remove IP");
      }
    } catch (error) {
      console.error("Error deleting IP:", error);
      toast.error("Error removing IP address");
    }
  };

  useEffect(() => {
    if (!gridRef.current) return;
    const source = {
      datatype: "json",
      datafields: [
        { name: "id", type: "string" },
        { name: "ip_address", type: "string" },
        { name: "description", type: "string" },
        { name: "status", type: "string" },
      ],
      localdata: gridData,
    };
    const dataAdapter = new window.$.jqx.dataAdapter(source);
    const columns = [
      {
        text: "Activities",
        cellsrenderer: function () {
          return (
            '<div class="grid_actions"><img src="' +
            edit +
            '" class="row_edit" /><img src="' +
            trash +
            '" class="row_delete" /></div>'
          );
        },
        width: "12%",
      },
      { text: "IP Address", filtertype: "textbox", datafield: "ip_address", width: "30%" },
      { text: "Description", filtertype: "textbox", datafield: "description", width: "38%" },
      { text: "Status", filtertype: "textbox", datafield: "status", width: "20%" },
    ];

    const gridOptions = {
      width: "100%",
      source: dataAdapter,
      columns: columns,
      autoheight: true,
      sortable: true,
      altrows: false,
      enabletooltips: true,
      editable: false,
      pageable: true,
      pageSize: 10,
      pagerButtonsCount: 10,
      pagerMode: "advanced",
      filterable: true,
      filterrowheight: 45,
      showfilterrow: true,
      rowsheight: 50,
      columnsheight: 45,
    };

    const $grid = window.$(gridRef.current);
    const isInitialized = $grid.hasClass("jqx-grid");

    if (isInitialized) {
      $grid.jqxGrid({ source: dataAdapter, columns });
      $grid.jqxGrid("updatebounddata");
      return;
    }

    $grid.jqxGrid(gridOptions);
    $grid.find(".jqx-grid-column-header").css("background-color", "white");

    $grid.on("click", ".row_edit", function () {
      const rowDiv = window.$(this).closest('[role="row"]');
      const rowIndex = window.$(rowDiv).attr("row-id");
      const rowData = $grid.jqxGrid("getrowdata", rowIndex);
      setEditId(rowData?.id);
      setFormData({
        ip_address: rowData?.ip_address || "",
        description: rowData?.description || "",
      });
      setModalShow(true);
    });

    $grid.on("click", ".row_delete", function () {
      const rowDiv = window.$(this).closest('[role="row"]');
      const rowIndex = window.$(rowDiv).attr("row-id");
      const rowData = $grid.jqxGrid("getrowdata", rowIndex);
      setDeleteId(rowData?.id);
      handleShowConfirmation(deleteRow);
    });
  }, [gridData]);

  return (
    <>
      {/* <Header
        logo_url={SBack ? SBack : `/ForwarderShipments/${shpTab ? shpTab : "ShipmentRecords"}`}
        sBackUrl={SBack ? SBack : `/ForwarderShipments/${shpTab ? shpTab : "ShipmentRecords"}`}
      />

      <div className="page-body-wrapper schedule">
        <LeftMenu />

        <div className="main-panel">
          <div className="row">
            <LeftSettings /> */}

      <div className="col-9 col-xxl-9 stting_right">
        <div className="settingbg_right">
          <h4>Driver Visitor IP Settings</h4>
          <p>Add IP addresses to control driver/visitor access.</p>
          <div className="d-flex justify-content-between">
            <div>
              <Button variant="primary createplan" onClick={handleAddButtonClick}>
                <FontAwesomeIcon icon={faPlus} /> Add IP
              </Button>
            </div>
          </div>
          <div ref={gridRef} className="bookinggrid userstting mt-3"></div>
        </div>
      </div>
      {/* </div>
        </div>
      </div> */}
      <Modal show={modalShow} centered onHide={handleModalClose} className="addfrom">
        <Modal.Header closeButton>
          <Modal.Title>{editId ? "Edit IP Address" : "Add IP Address"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Col sm="12">
              <Form.Label>IP Address</Form.Label>
              <Form.Control
                type="text"
                name="ip_address"
                placeholder="e.g. 192.168.0.10"
                value={formData.ip_address}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, ip_address: e.target.value }))
                }
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-2">
            <Col sm="12">
              <Form.Label>Description (optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                placeholder="Add context for this IP"
                value={formData.description}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, description: e.target.value }))
                }
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            {editId ? "Update IP" : "Add IP"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="raintrac" show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h2>Confirm Delete</h2>
          <p>
            If you proceed, this IP address will be removed. Are you sure you
            want to continue?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            No
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DriverVisitorSettings;
